import { useQuery } from "react-query";
import { getIOFormLookups } from "@/api/Histories/io-api";

const key = "io-integration";

export function useIOLookups(historyId, options = {}) {
	return useQuery([key, historyId], () => getIOFormLookups(historyId || ""), {
		staleTime: 5 * 60 * 1000,
		cacheTime: 10 * 60 * 1000,
		retry: 1,
		onError: (error) => {
			console.error("Error fetching history output lookups:", error);
		},
		...options,
	});
}
